import { MessageEntity }          from './MessageEntity';

export class DialogEntity {

    /**
     * Constructor.
     * 
     * @param timestamp - the timestamp of the creation of the dialog
     * @param messages - the messages list associated to this dialog
     */
    constructor(public timestamp: number,
                public messages: MessageEntity[]) {}

    public addNewMessages(newMessages: MessageEntity[]) {
        newMessages.forEach((message: MessageEntity) => {
            this.messages.push(message);
        });
    }

    public addNewMessage(newMessage: MessageEntity) {
        this.messages.push(newMessage);
    }
}